const actions = {
  SET_USER_DATA: 'SET_USER_DATA',
  SET_WORKSPACE_SETTINGS: 'SET_WORKSPACE_SETTINGS',
  SET_WORKSPACE_USERS: 'SET_WORKSPACE_USERS',
  SET_NOTIFICATION: 'SET_NOTIFICATION',
  SET_ALL_NOTIFICATION: 'SET_ALL_NOTIFICATION',
};

export default actions;
